<template>
<w-select class="mt4" :items="d_tahun" label="Tahun"  v-model="carian.tahun" @input="getData(2)"/><br>
 <div class="dashboard1">
    <div class="card5" v-for="(card, index) in cards2" :key="index" @click="item(index)">
      <div class="card-icon">
        <h2>{{ card.keterangan }}</h2>
      </div>
      <div class="card-info1">
         <p>{{ card.jumlah }}</p>
      </div>
    </div>
  </div>
  <br>
</template>

<script>
import { GChart } from "vue-google-charts";
export default {
   props: {
    d_tahun: [Array, Object],
   },
  name: "Kawalan",
  components: {
        GChart
  },
  data() {
    return {
      cards: [
        { id: 1, title: 'DRAFT', count: 1500, icon: 'fas fa-users' },
        { id: 2, title: 'HANTAR', count: 1200, icon: 'fas fa-user-check' },
        // { id: 3, title: 'PROSES', count: 300, icon: 'fas fa-user-plus' },
      ],
      cards2:[],
      carian: { tahun: "" },
    }
  },
  methods:{
    getData(item){
      if(item==1){
        var today = new Date();
        this.carian.tahun = today.getFullYear(); 
      }
      this.$zcomm.get(this.api_service + 'tangki_daftar/dashboard_tangki?tahun='+this.carian.tahun, {}).then(res => {
        this.cards2 = res
      })
    },
   item(index){
      if(index==1){
         var hantar = 1;
      }else{
         var hantar = 2;
      } 
      window.location.href = window.route('tangki.daftar.index')+'?hantar='+hantar;
    },
  },
      
  mounted() {
    this.getData(1)
  }
}
      

</script>  
<style type="text/css">
  .dashboard {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 30px;
  padding: 20px;
  background-color: #f5f5f5;
}

.card5 {
  background: linear-gradient(135deg, #42a5f5, #478ed1);
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
}

.card5:hover {
  transform: translateY(-10px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2);
}

.card-icon1 {
  font-size: 60px;
  margin-right: 95px;
  margin-bottom: 15px;
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.3s;
}

.card5:hover .card-icon1 {
  color: #fff;
}

.card-icon {
  font-size: 60px;
  margin-bottom: 15px;
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.3s;
}

.card3:hover .card-icon {
  color: #fff;
}

.card-info1 h2 {
  margin: 0;
  font-size: 18px;
  margin-right: 95px;
  font-weight: bold;
  color: #f1f1f1;
  letter-spacing: 1px;
}

.card-info1 p {
  margin-top: 8px;
  margin-right: 95px;
  font-size: 60px;
  font-weight: bold;
  color: #fff;
}

.card5:nth-child(1) {
  background: linear-gradient(135deg, rgb(245 163 49 / 8%), rgb(245 162 49)), url(/images/draf.png) center / cover no-repeat;
 /* background: linear-gradient(135deg, rgba(66, 165, 245, 0.7), rgba(71, 142, 209, 0.7)),
              url('/images/check.png') center/cover no-repeat;*/
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
/*  background: linear-gradient(135deg, #66bb6a, #43a047);*/
}

/*.card2:nth-child(3) {
  background: linear-gradient(135deg, rgb(84 173 73 / 22%), rgb(87 177 78)), url(/images/proses.png) center / cover no-repeat;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
/*  background: linear-gradient(135deg, #ffa726, #fb8c00);*/


.card5:nth-child(2) {
  background: linear-gradient(135deg, rgb(75 156 219 / 27%), rgb(80 149 208)), url(/images/biru1.png) center / cover no-repeat;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  padding: 20px;
  width: 250px;
  text-align: center;
  color: #fff;
  transition: transform 0.3s, box-shadow 0.3s;
/*  background: linear-gradient(135deg, #ea1e1e, #e15252);*/
}



</style>
